import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';

function euro(v) { return Number(v || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
function fmtDate(s) { if (!s) return '—'; const d = new Date(s.replace(' ', 'T') + 'Z'); return d.toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' }); }

const ROLE_LABEL = { admin: 'Administrator', user: 'Benutzer' };
const ROLE_COLOR = { admin: '#10b981', user: '#6366f1' };

function Badge({ label, color }) {
  return <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: color + '22', color }}>{label}</span>;
}

function PwPolicy() {
  return <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Mind. 12 Zeichen, Groß-/Kleinbuchstaben, Zahl, Sonderzeichen</div>;
}

function Alert({ type, msg, onClose }) {
  if (!msg) return null;
  const colors = { error: ['#fff1f2', '#ef4444'], success: ['#f0fdf4', '#10b981'], warn: ['#fffbeb', '#f59e0b'] };
  const [bg, fg] = colors[type] || colors.warn;
  return (
    <div style={{ background: bg, border: `1px solid ${fg}33`, borderRadius: 8, padding: '10px 14px', fontSize: 13, color: fg, display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
      <span>{msg}</span>
      {onClose && <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: fg, fontSize: 16, marginLeft: 8 }}>✕</button>}
    </div>
  );
}

function ChangePasswordForm({ onDone }) {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [ok, setOk] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      await api.post('/account/change-password', form);
      setOk(true);
      setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (ex) {
      setErr(ex.response?.data?.error || ex.message);
    } finally { setLoading(false); }
  }

  if (ok) return <Alert type="success" msg="Passwort erfolgreich geändert. Andere Sitzungen wurden abgemeldet." onClose={onDone} />;

  return (
    <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 360 }}>
      <Alert type="error" msg={err} onClose={() => setErr('')} />
      {['currentPassword', 'newPassword', 'confirmPassword'].map((f, i) => (
        <input key={f} type="password" placeholder={['Aktuelles Passwort', 'Neues Passwort', 'Neues Passwort wiederholen'][i]}
          value={form[f]} onChange={e => setForm(v => ({ ...v, [f]: e.target.value }))}
          required style={{ padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13, width: '100%' }} />
      ))}
      <PwPolicy />
      <button type="submit" disabled={loading} style={{ padding: '8px 16px', background: '#0a6f4f', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
        {loading ? 'Speichern...' : 'Passwort ändern'}
      </button>
    </form>
  );
}

function CreateUserForm({ onCreated, onCancel }) {
  const [form, setForm] = useState({ username: '', display_name: '', password: '', role: 'user', email: '' });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  async function submit(e) {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const r = await api.post('/admin/users', form);
      onCreated(r.data.user);
    } catch (ex) {
      setErr(ex.response?.data?.error || ex.message);
    } finally { setLoading(false); }
  }

  return (
    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: 18, marginBottom: 16 }}>
      <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 12 }}>Neuen Benutzer anlegen</div>
      <Alert type="error" msg={err} onClose={() => setErr('')} />
      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <input type="text" placeholder="Benutzername *" value={form.username} required
            onChange={e => setForm(v => ({ ...v, username: e.target.value }))}
            style={{ padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13 }} />
          <input type="text" placeholder="Anzeigename" value={form.display_name}
            onChange={e => setForm(v => ({ ...v, display_name: e.target.value }))}
            style={{ padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13 }} />
          <input type="password" placeholder="Passwort *" value={form.password} required
            onChange={e => setForm(v => ({ ...v, password: e.target.value }))}
            style={{ padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13 }} />
          <select value={form.role} onChange={e => setForm(v => ({ ...v, role: e.target.value }))}
            style={{ padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13 }}>
            <option value="user">Benutzer</option>
            <option value="admin">Administrator</option>
          </select>
          <input type="email" placeholder="E-Mail (optional)" value={form.email}
            onChange={e => setForm(v => ({ ...v, email: e.target.value }))}
            style={{ padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13, gridColumn: '1 / -1' }} />
        </div>
        <PwPolicy />
        <div style={{ fontSize: 11, color: '#b45309' }}>Der neue Benutzer muss dieses Startpasswort bei der ersten Anmeldung ändern.</div>
        <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
          <button type="submit" disabled={loading} style={{ padding: '8px 16px', background: '#0a6f4f', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
            {loading ? 'Anlegen...' : 'Benutzer anlegen'}
          </button>
          <button type="button" onClick={onCancel} style={{ padding: '8px 16px', background: 'white', border: '1px solid #e2e8f0', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>Abbrechen</button>
        </div>
      </form>
    </div>
  );
}

function UserRow({ user, currentUserId, onAction }) {
  const [resetting, setResetting] = useState(false);
  const [tempPw, setTempPw] = useState('');
  const [actionErr, setActionErr] = useState('');

  async function doReset() {
    if (!window.confirm(`Passwort für "${user.username}" wirklich zurücksetzen?`)) return;
    setResetting(true); setActionErr(''); setTempPw('');
    try {
      const r = await api.post(`/admin/users/${user.id}/reset-password`);
      setTempPw(r.data.tempPassword);
      onAction();
    } catch (ex) { setActionErr(ex.response?.data?.error || ex.message); }
    finally { setResetting(false); }
  }

  async function doToggleActive() {
    const msg = user.is_active ? `"${user.username}" wirklich deaktivieren?` : `"${user.username}" wieder aktivieren?`;
    if (!window.confirm(msg)) return;
    try {
      await api.put(`/admin/users/${user.id}`, { is_active: user.is_active ? 0 : 1 });
      onAction();
    } catch (ex) { setActionErr(ex.response?.data?.error || ex.message); }
  }

  async function doLogoutAll() {
    if (!window.confirm(`Alle Sitzungen von "${user.username}" wirklich beenden?`)) return;
    try {
      await api.post(`/admin/users/${user.id}/logout-all`);
      onAction();
    } catch (ex) { setActionErr(ex.response?.data?.error || ex.message); }
  }

  const isCurrentUser = user.id === currentUserId;

  return (
    <>
      <tr style={{ background: user.is_active ? 'white' : '#fafafa', opacity: user.is_active ? 1 : 0.7 }}>
        <td style={{ padding: '10px 8px' }}>
          <div style={{ fontWeight: 700, fontSize: 13 }}>{user.username}</div>
          {user.display_name && <div style={{ fontSize: 11, color: '#94a3b8' }}>{user.display_name}</div>}
          {isCurrentUser && <Badge label="Du" color="#6366f1" />}
        </td>
        <td style={{ padding: '10px 8px' }}><Badge label={ROLE_LABEL[user.role] || user.role} color={ROLE_COLOR[user.role] || '#94a3b8'} /></td>
        <td style={{ padding: '10px 8px' }}>
          <Badge label={user.is_active ? 'Aktiv' : 'Deaktiviert'} color={user.is_active ? '#10b981' : '#94a3b8'} />
          {user.locked_until && <div style={{ fontSize: 11, color: '#f59e0b', marginTop: 2 }}>Gesperrt bis {fmtDate(user.locked_until)}</div>}
        </td>
        <td style={{ padding: '10px 8px', fontSize: 12, color: '#64748b' }}>
          <div>Erstellt: {fmtDate(user.created_at)}</div>
          <div>Login: {fmtDate(user.last_login_at)}</div>
          {user.active_sessions > 0 && <div style={{ color: '#10b981' }}>{user.active_sessions} aktive Sitzung(en)</div>}
        </td>
        <td style={{ padding: '10px 8px', textAlign: 'right' }}>
          <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button onClick={doReset} disabled={resetting} style={{ padding: '4px 8px', fontSize: 11, border: '1px solid #e2e8f0', borderRadius: 5, cursor: 'pointer', background: 'white' }}>
              {resetting ? '...' : 'PW Reset'}
            </button>
            {user.active_sessions > 0 && (
              <button onClick={doLogoutAll} style={{ padding: '4px 8px', fontSize: 11, border: '1px solid #fbbf24', borderRadius: 5, cursor: 'pointer', background: '#fffbeb', color: '#b45309' }}>
                Abmelden
              </button>
            )}
            {!isCurrentUser && (
              <button onClick={doToggleActive} style={{ padding: '4px 8px', fontSize: 11, border: `1px solid ${user.is_active ? '#ef4444' : '#10b981'}`, borderRadius: 5, cursor: 'pointer', background: 'white', color: user.is_active ? '#ef4444' : '#10b981' }}>
                {user.is_active ? 'Deaktivieren' : 'Aktivieren'}
              </button>
            )}
          </div>
        </td>
      </tr>
      {(tempPw || actionErr) && (
        <tr>
          <td colSpan={5} style={{ padding: '0 8px 10px' }}>
            {tempPw && (
              <div style={{ background: '#f0fdf4', border: '1px solid #10b98133', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#065f46' }}>
                <strong>Temporäres Passwort (einmalig angezeigt):</strong><br />
                <code style={{ fontFamily: 'monospace', fontSize: 14, letterSpacing: 1 }}>{tempPw}</code>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Dieses Passwort wird nirgendwo gespeichert. Bitte jetzt notieren.</div>
              </div>
            )}
            {actionErr && <Alert type="error" msg={actionErr} onClose={() => setActionErr('')} />}
          </td>
        </tr>
      )}
    </>
  );
}

export default function UserManagementPage() {
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [showCreate, setShowCreate] = useState(false);
  const [showChangePw, setShowChangePw] = useState(false);

  const loadUsers = useCallback(async () => {
    setLoading(true); setErr('');
    try {
      const [ures, me] = await Promise.all([api.get('/admin/users'), api.get('/auth/me')]);
      setUsers(ures.data.users);
      setCurrentUser(me.data.user);
    } catch (ex) {
      setErr(ex.response?.data?.error || ex.message);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  if (loading) return <div style={{ color: '#64748b', fontSize: 13, padding: 20 }}>Lade Benutzerverwaltung...</div>;

  return (
    <div>
      {/* Architektur-Hinweis */}
      <div style={{ background: '#fffbeb', border: '1px solid #fbbf2433', borderRadius: 8, padding: '10px 14px', fontSize: 12, color: '#92400e', marginBottom: 16 }}>
        <strong>Hinweis:</strong> Alle Benutzer sehen denselben Finanzdatenbestand (keine Benutzer-Isolation). Rollen steuern ausschließlich Berechtigungen (Admin: Nutzerverwaltung; Benutzer: Finanzanalyse).
      </div>

      <Alert type="error" msg={err} onClose={() => setErr('')} />

      {/* Benutzerliste */}
      <div className="an-card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#1e293b' }}>Benutzerliste ({users.length})</div>
          <button onClick={() => setShowCreate(v => !v)} style={{ padding: '6px 14px', background: showCreate ? '#f1f5f9' : '#0a6f4f', color: showCreate ? '#64748b' : 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
            {showCreate ? 'Abbrechen' : '+ Benutzer anlegen'}
          </button>
        </div>

        {showCreate && <CreateUserForm onCreated={u => { loadUsers(); setShowCreate(false); }} onCancel={() => setShowCreate(false)} />}

        <div style={{ overflowX: 'auto' }}>
          <table className="an-table" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Benutzer</th>
                <th>Rolle</th>
                <th>Status</th>
                <th>Daten</th>
                <th style={{ textAlign: 'right' }}>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <UserRow key={u.id} user={u} currentUserId={currentUser?.id} onAction={loadUsers} />
              ))}
              {users.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: '#94a3b8', padding: 20, fontSize: 12 }}>Keine Benutzer</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Eigenes Passwort aendern */}
      <div className="an-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: showChangePw ? 14 : 0 }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#1e293b' }}>Eigenes Passwort ändern</div>
          <button onClick={() => setShowChangePw(v => !v)} style={{ padding: '6px 14px', background: '#f1f5f9', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
            {showChangePw ? 'Schließen' : 'Passwort ändern'}
          </button>
        </div>
        {showChangePw && <ChangePasswordForm onDone={() => setShowChangePw(false)} />}
      </div>
    </div>
  );
}
